import React from 'react';
import { createRoot } from 'react-dom/client';
import RearMountedChildBikeSeats from './RearMountedChildBikeSeats.tsx';
import * as Sentry from '@sentry/react';
import { AppStateProvider } from './State.tsx';

const rootElement = document.getElementById('REACT_FitAssistant_new');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <AppStateProvider>
      <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
        <RearMountedChildBikeSeats />
      </Sentry.ErrorBoundary>
    </AppStateProvider>
  );
}
